export { BaseModal, ConfirmModal } from './base-modal';
export type { BaseModalProps, ConfirmModalProps } from './base-modal';
